import React, { useEffect, JSX } from "react";
import { useQuery } from "@apollo/client/react";

import { CLIENT_QUERY } from "queries/newClient";

import Client from "./client";
import { useLocation } from "wouter";
import { Client as ClientType } from "generated/graphql";

const NewClientShell = ({
  id,
  abacusId,
  tab,
}: {
  id?: string;
  abacusId?: string;
  tab?: string;
}): JSX.Element => {
  const { data, loading } = useQuery(CLIENT_QUERY, {
    variables: { id, abacusId },
  });
  const [_location, navigate] = useLocation();
  const params: { tab?: string } = { tab };
  const loadedId = id ?? (data?.client as Partial<ClientType>)?.id;

  useEffect(() => {
    if (!id && abacusId && loadedId) {
      const tab = params.tab ? `/${params.tab}` : "";
      navigate(`/client/${loadedId}${tab}`, { replace: true });
    }
  }, [loadedId]);

  return (
    <Client
      id={loadedId ?? ""}
      client={data?.client as Partial<ClientType>}
      loading={loading}
      tab={tab}
    />
  );
};

export default NewClientShell;
